import React, { useState, useEffect } from "react";
import "../my_styles/myStyles.css";
import { main_link } from "../Connection/Connection";
import useFetch from "../Fetch_Folder/useFetch";
import { FilterMatchMode, FilterService } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import Spinner from "react-bootstrap/Spinner";
import AddCustomerCutModel from "../Modals/AddCustomerCutModel";
import { use } from "react";
import EditCustomerCutModal from "../Modals/EditCustomerCutModal";

//
const MyCuts = () => {
  const user = JSON.parse(sessionStorage.getItem("user-data"));
  const user_id = user["encrypted_id"];

  const [show, setShow] = useState(false);
  const [counter, setCounter] = useState(0);

  const {
    error,
    isLoading: isLoadingAllMyCuts,
    data: customersCuts,
  } = useFetch(`${main_link}getAllMyCuts?user_id=${user_id}`, counter);

  // console.log(customersCuts);

  const [filters, setFilters] = useState({
    index: { value: null, matchMode: FilterMatchMode.CONTAINS },
    customer: { value: null, matchMode: FilterMatchMode.CONTAINS },
    created_by_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    hair: { value: null, matchMode: FilterMatchMode.CONTAINS },
    beard: { value: null, matchMode: FilterMatchMode.CONTAINS },
    face: { value: null, matchMode: FilterMatchMode.CONTAINS },
    regAt: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const [showCut, setShowCut] = useState(false);
  const [cutData, setCutData] = useState([]);
  const showCutTemplate = (rowData) => (
    <Button
      type="button"
      icon="nav-icon fas fa-edit"
      style={{ borderRadius: "50px" }}
      onClick={() => {
        setShowCut(true);
        setCutData(rowData);
        // console.log(rowData);
        setShowEditModal(true);
      }}
    />
  );

  const [showEditModal, setShowEditModal] = useState(false);

  return (
    <>
      <EditCustomerCutModal
        show={showEditModal}
        setShow={setShowEditModal}
        counter={counter}
        setCounter={setCounter}
        cutData={cutData}
      />
      <AddCustomerCutModel
        show={show}
        setShow={setShow}
        counter={counter}
        setCounter={setCounter}
      />
      <div>
        {/* Content Wrapper. Contains page content */}
        <div className="content-wrapper">
          {/* Content Header (Page header) */}
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>Customers Cut</h1>
                </div>
              </div>
            </div>
          </section>
          {/* Main content */}
          <section className="content">
            {/* Default box */}
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">
                  Customers Cut{" "}
                  {isLoadingAllMyCuts && (
                    <Spinner
                      size="sm"
                      animation="border"
                      role="status"
                    ></Spinner>
                  )}
                </h3>
                <div className="card-tools">
                  <i
                    className="fas fa-plus-circle fa-2x icon"
                    data-toggle="modal"
                    data-target="#addNewCutModel"
                  ></i>
                </div>
              </div>
              <DataTable
                value={customersCuts}
                sortMode="multiple"
                tableStyle={{ minWidth: "50rem" }}
                paginator
                rows={10}
                dataKey="index"
                filters={filters}
                filterDisplay="row"
                loading={isLoadingAllMyCuts}
                scrollable
                removableSort
                stripedRows
              >
                <Column
                  field="index"
                  header="ID"
                  sortable
                  style={{ width: "8%" }}
                  filter
                  filterPlaceholder="Search by ID"
                ></Column>
                <Column
                  field="customer"
                  header="Customer"
                  sortable
                  style={{ width: "15%" }}
                  filter
                  filterPlaceholder="Search by Customer"
                ></Column>
                <Column
                  field="created_by_name"
                  header="Barber"
                  sortable
                  filter
                  filterPlaceholder="Search by Barber"
                ></Column>
                <Column
                  field="hair"
                  header="Hair"
                  sortable
                  filter
                  filterPlaceholder="Search by Hair"
                ></Column>
                <Column
                  field="beard"
                  header="Beard"
                  sortable
                  filter
                  filterPlaceholder="Search by Beard"
                ></Column>
                <Column
                  field="face"
                  header="Face"
                  sortable
                  filter
                  filterPlaceholder="Search by Face"
                ></Column>
                <Column
                  field="regAt"
                  header="Created"
                  sortable
                  filter
                  filterPlaceholder="Search by Reg Date"
                ></Column>
                <Column
                  header="Edit"
                  headerStyle={{ width: "5rem", textAlign: "center" }}
                  bodyStyle={{ textAlign: "center", overflow: "visible" }}
                  body={showCutTemplate}
                />
              </DataTable>
              {/* /.card-body */}
              <div className="card-footer">Barbers Cut</div>
              {/* /.card-footer*/}
            </div>
            {/* /.card */}
          </section>
          {/* /.content */}
        </div>
        {/* /.content-wrapper */}
      </div>
    </>
  );
};

export default MyCuts;
